import React from 'react';
import { MapPin } from 'lucide-react';
import { LocationBlock } from '../../components/LocationBlock';
const STUDIO = {
  street: '24786 Crestview',
  cityStateZip: 'Farmington Hills, MI 48335'
};
export function ContactMap() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-877">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-878">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-879">
          <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-880">
            <MapPin className="w-3.5 h-3.5" data-id="element-881" />
            Find Storm Taekwondo
          </div>
          <h2 className="text-3xl md:text-4xl text-ink mb-4" data-id="element-882">
            Visit Us in Farmington Hills
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-883">
            {STUDIO.street}, {STUDIO.cityStateZip}
          </p>
        </div>
        <LocationBlock data-id="element-884" />
      </div>
    </section>;
}